import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { mapOptions } from './mapDefaults';
import useGoogleMap from './useGoogleMap';

const GMap = styled.div`
  width: 100%;
  height: 100%;

  ${({ isICSP }) => {
    return isICSP
      ? `border-radius: 5px;
    border: 1px solid #5B778D;
    `
      : '';
  }}
`;

/**
 * Google Maps container
 * @param {String} apiKey - API key for Google Maps
 * @param {Object} mapOptions - Google maps options
 * @param {Function} onReady - Callback for when the map is ready
 * @param {boolean} isICSP - is incident central station or not
 */
const GoogleMap = ({ apiKey, mapOptions, onReady, isICSP }) => {
  const updatedMapOptions = {
    ...mapOptions,
    controlSize: isICSP ? '25' : '40',
  };
  const { mapInstance, mapRef, initialized } = useGoogleMap({
    apiKey,
    options: updatedMapOptions,
    styles: [],
  });

  // Callback for when map is ready
  useEffect(() => {
    onReady(mapInstance, mapRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialized]);

  return <GMap ref={mapRef} isICSP={isICSP} />;
};

GoogleMap.propTypes = {
  apiKey: PropTypes.string.isRequired,
  mapOptions: PropTypes.object,
  onReady: PropTypes.func.isRequired,
};

GoogleMap.defaultProps = {
  mapOptions,
};

export default GoogleMap;
